import { Reducer } from 'redux';
import {
  UserEmailConfirmationState,
  UserEmailConfirmationActionTypes,
  USER_EMAIL_CONFIRMATION_INPROGESS,
  USER_EMAIL_CONFIRMATION_SUCCESS,
  USER_EMAIL_CONFIRMATION_FAILURE,
  VERIFY_USER_EMAIL_CONFIRMATION_INPROGESS,
  VERIFY_USER_EMAIL_CONFIRMATION_SUCCESS,
  VERIFY_USER_EMAIL_CONFIRMATION_FAILURE,
} from './types';
import * as Bixby from '$/core';

const initialState: UserEmailConfirmationState = {
  isLoading: false,
  error: '',
  success: false,
  tokenInvalid: false,
};

const resetPasswordReducer: Reducer<UserEmailConfirmationState> = (
  state = initialState,
  action: UserEmailConfirmationActionTypes
): UserEmailConfirmationState => {
  switch (action.type) {
    case VERIFY_USER_EMAIL_CONFIRMATION_INPROGESS:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case VERIFY_USER_EMAIL_CONFIRMATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tokenInvalid: action.payload === false,
      };
    case VERIFY_USER_EMAIL_CONFIRMATION_FAILURE:
      return {
        ...state,
        success: false,
      };
    case USER_EMAIL_CONFIRMATION_INPROGESS:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case USER_EMAIL_CONFIRMATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case USER_EMAIL_CONFIRMATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: Bixby.API.getErrorMessage((action.payload || {}) as Error),
        success: false,
      };
    default:
      return state;
  }
};
export default resetPasswordReducer;
